import * as moment from 'moment';

import {
  APP_DATE_FORMAT,
  DB_DATE_FORMAT,
} from "../_constants/common.constant";
import {Moment} from "moment";

export class DateHelper {

  static getRemainingDays(targetDateStr: string): string {
    const today: Date = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight

    const targetDate: Date = new Date(targetDateStr);
    targetDate.setHours(0, 0, 0, 0); // Reset time to midnight

    const diffTime: number = targetDate.getTime() - today.getTime(); // Difference in milliseconds
    const diffDays: number = Math.floor(diffTime / (1000 * 60 * 60 * 24)); // Convert to days

    return diffDays > 0 ? `${diffDays} day(s)` : "0 day";
  }

  static expiredIn(dbDate: string) {
      const givenDate = new Date(dbDate);
      const today = new Date();

      // Ensure time comparison is only by date (ignoring hours, minutes, etc.)
      today.setHours(0, 0, 0, 0);
      givenDate.setHours(0, 0, 0, 0);

      if (givenDate <= today) {
        return "Expired"; // Handle past dates
      }

      const diffInDays = Math.floor((givenDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

      if (diffInDays <= 60) {
        return `${diffInDays} day(s)`;
      }

      let years = givenDate.getFullYear() - today.getFullYear();
      let months = givenDate.getMonth() - today.getMonth();

      if (months < 0) {
        years -= 1;
        months += 12;
      }

      let result = "";
      if (years > 0) {
        result += `${years} year${years > 1 ? "(s)" : "(s)"}`;
      }
      if (months > 0) {
        if (result) result += " "; // Add space if years exist
        result += `${months} month${months > 1 ? "(s)" : "(s)"}`;
      }

      return result;

  }

  static timeAgo(date: Date | string | number): string {
    const now = new Date();
    const past = new Date(date);
    const seconds = Math.floor((now.getTime() - past.getTime()) / 1000);

    if (seconds < 60) return `${seconds} seconds ago`;

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} minutes ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hours ago`;

    const days = Math.floor(hours / 24);
    if (days < 30) return `${days} days ago`;

    const months = Math.floor(days / 30);
    if (months < 12) return `${months} months ago`;

    const years = Math.floor(days / 365);
    return `${years} years ago`;
  }

  static formatDateMonthYearOnly(inputDate: string): string {
    const date = new Date(inputDate);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    return `${month}/${year}`
  }
  static localeDate(date: string, locale: string): string {
    return moment(date, DB_DATE_FORMAT).locale(locale).format(APP_DATE_FORMAT).toString();
  }
  static momentToDbDate(date: Moment): any {
    return date.format(DB_DATE_FORMAT).toString();
  }

  static stripeDateChange(date: string) {
    let newDate = date.split('/');
    return newDate[1] + '/' + newDate[0] + '/' + newDate[2];
  }
}
